(function () {
  const currentHost = window.location.hostname.toLowerCase();

  function isInternalLink(href) {
    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return true;
    }

    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return true;
    }

    const host = url.hostname.toLowerCase();
    if (host === currentHost) return true;

    // Keep jafra.com family in the same tab when already on a jafra.com host.
    if (currentHost === "jafra.com" || currentHost.endsWith(".jafra.com")) {
      return host === "jafra.com" || host.endsWith(".jafra.com");
    }

    return false;
  }

  document.querySelectorAll("a[href]").forEach((link) => {
    if (!link.href || link.hasAttribute("target")) return;

    if (!isInternalLink(link.href)) {
      link.setAttribute("target", "_blank");
      if (!link.getAttribute("rel")) {
        link.setAttribute("rel", "noopener noreferrer");
      }
    }
  });
})();
